import axios from 'axios';
import config from './config';
import { goToLogin } from './navigation'; // update path if needed
import { getAuthToken } from './helpers';

const SERVER_BASE_URL = config.SERVER_BASE_URL;

// Reusable error handler
const handleApiError = (error, context = '') => {
  if (!error?.response && error?.code === 'ERR_NETWORK') {
    goToLogin(); // ✅ Redirect to login on network error
  }else {
    console.error(`Error ${context}:`, error);
  }
  throw error;
};

// GET schema
export const getSportSchema = async (sport) => {
  try {
    const response = await axios.get(`${SERVER_BASE_URL}/api/sourcing/${sport}/schema`, {
      headers: {
        Authorization: getAuthToken(),
      },
    });
    return response.data.data;
  } catch (error) {
    handleApiError(error, 'fetching sport schema');
  }
};

// POST search
export const searchProspects = async (sport, criteria, options = {}) => {
  try {
    const response = await axios.post(
      `${SERVER_BASE_URL}/api/sourcing/${sport}/prospects/search`,
      { criteria, options },
      {
        headers: {
          Authorization: getAuthToken(),
        },
      }
    );
    return response.data.data;
  } catch (error) {
    handleApiError(error, 'searching prospects');
  }
};

// POST analyze gaps
export const analyzeRosterGaps = async (sport, currentRoster, requirements) => {
  try {
    const response = await axios.post(
      `${SERVER_BASE_URL}/api/sourcing/${sport}/analyze/gaps`,
      { currentRoster, requirements },
      {
        headers: {
          Authorization: getAuthToken(),
        },
      }
    );
    return response.data.data;
  } catch (error) {
    handleApiError(error, 'analyzing roster gaps');
  }
};

// POST recommendations
export const getRecommendations = async (sport, teamNeeds, options = {}) => {
  try {
    const response = await axios.post(
      `${SERVER_BASE_URL}/api/sourcing/${sport}/recommendations`,
      { teamNeeds, options },
      {
        headers: {
          Authorization: getAuthToken(),
        },
      }
    );
    return response.data.data;
  } catch (error) {
    handleApiError(error, 'getting recommendations');
  }
};

// POST export
export const exportData = async (sport, data, format) => {
  try {
    const response = await axios.post(
      `${SERVER_BASE_URL}/api/sourcing/${sport}/export`,
      { data, format },
      {
        responseType: 'blob',
        headers: {
          Authorization: getAuthToken(),
        },
      }
    );
    return response.data;
  } catch (error) {
    handleApiError(error, 'exporting data');
  }
};

// GET metrics
export const getSportMetrics = async (sport) => {
  try {
    const response = await axios.get(`${SERVER_BASE_URL}/api/sourcing/${sport}/metrics`, {
      headers: {
        Authorization: getAuthToken(),
      },
    });
    return response.data.data;
  } catch (error) {
    handleApiError(error, 'fetching sport metrics');
  }
};

// POST validate
export const validateData = async (sport, data) => {
  try {
    const response = await axios.post(
      `${SERVER_BASE_URL}/api/sourcing/${sport}/validate`,
      { data },
      {
        headers: {
          Authorization: getAuthToken(),
        },
      }
    );
    return response.data.valid;
  } catch (error) {
    handleApiError(error, 'validating data');
  }
};
